import { useState } from 'react';
import { useHistory } from 'react-router';
import {
  AuthPanel,
  ChangePasswordForm,
  ChangePasswordFormValues,
  useToastNotifications,
} from '@nbirl/nbi-common-ui-libs';
import { FormikHelpers } from 'formik';

import { PATHS } from '../../shared/constants';
import { useAuth } from '../../shared/context';
import {
  useBodyClassName,
  useCognitoUser,
  useErrorToast,
} from '../../shared/hooks';

export const ChangePassword = () => {
  const [isPending, setIsPending] = useState(false);
  const { changePassword } = useAuth();
  const { email } = useCognitoUser();
  const { addToast } = useToastNotifications();
  const { showErrorToast } = useErrorToast();
  const history = useHistory();
  useBodyClassName('bg-primary-25');

  const handleSubmit = async (
    { oldPassword, newPassword }: ChangePasswordFormValues,
    formikHelpers: FormikHelpers<ChangePasswordFormValues>
  ) => {
    try {
      setIsPending(true);
      await changePassword(oldPassword, newPassword);
      addToast({
        variant: 'success',
        text: 'Password changed.',
      });
      history.push(PATHS.DocumentsHome);
    } catch (error: any) {
      setIsPending(false);

      if (error?.code === 'InvalidPasswordException') {
        formikHelpers.setFieldError('newPassword', error.message);
      } else if (error?.code === 'NotAuthorizedException') {
        formikHelpers.setFieldError('oldPassword', 'Incorrect password');
      } else {
        showErrorToast(error);
      }
    }
  };

  return (
    <div className="my-12">
      <AuthPanel>
        <ChangePasswordForm
          showOldPasswordField
          showBackButton={false}
          email={email}
          isPending={isPending}
          onSubmit={handleSubmit}
        />
      </AuthPanel>
    </div>
  );
};
